import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "flex items-start gap-2" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "font-semibold text-textPrimary" }
const _hoisted_5 = { class: "text-sm text-[#68688D]" }
const _hoisted_6 = ["data-testid"]

import { computed } from 'vue'
import { mdiCommentQuestionOutline, mdiInformationOutline } from '@mdi/js'
import type {
  ChangeReasonCode,
  ChangeReasonKind
} from '@/Network/Types/Requests/ChangeReasonRequests'
import {
  CHANGE_REASON_ERROR_MESSAGES,
  CHANGE_REASON_HELP_TEXT,
  CHANGE_REASON_NOTE_MAX,
  changeReasonNoteLength,
  getChangeReasonError,
  type ChangeReasonOption,
  type ChangeReasonValue
} from '@/utils/changeReasons'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeReasonField',
  props: {
    kind: {},
    title: {},
    label: {},
    options: {},
    modelValue: {},
    showErrors: { type: Boolean, default: false },
    scopeNote: { default: '' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const requiresText = computed(
  () => props.options.find((o) => o.value === props.modelValue.code)?.requiresText ?? false
)
const error = computed(() =>
  props.showErrors ? getChangeReasonError(props.modelValue, props.options) : null
)
const codeErrors = computed(() =>
  error.value === 'CODE_REQUIRED' ? [CHANGE_REASON_ERROR_MESSAGES.CODE_REQUIRED] : []
)
const noteErrors = computed(() =>
  error.value && error.value !== 'CODE_REQUIRED' ? [CHANGE_REASON_ERROR_MESSAGES[error.value]] : []
)

function onCode(code: ChangeReasonCode | null) {
  emit('update:modelValue', { code: code ?? null, note: props.modelValue.note })
}

function onNote(note: string | null) {
  emit('update:modelValue', { code: props.modelValue.code, note: note ?? '' })
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col gap-3 text-left rounded-lg border border-primary/20 bg-primary/5 p-4",
    "data-testid": `change-reason-field-${_ctx.kind}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, {
        icon: _unref(mdiCommentQuestionOutline),
        color: "primary",
        size: "22"
      }, null, 8, ["icon"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title) + " *", 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(CHANGE_REASON_HELP_TEXT)), 1)
      ])
    ]),
    _createVNode(_component_v_select, {
      "model-value": _ctx.modelValue.code,
      "menu-props": { maxHeight: 560 },
      items: _ctx.options,
      "item-title": "title",
      "item-value": "value",
      label: _ctx.label,
      placeholder: "Informe aqui o motivo dessa alteração",
      "persistent-placeholder": "",
      variant: "outlined",
      color: "primary20",
      "bg-color": "white",
      density: "comfortable",
      "error-messages": codeErrors.value,
      "hide-details": codeErrors.value.length === 0,
      "data-testid": `change-reason-select-${_ctx.kind}`,
      "onUpdate:modelValue": onCode
    }, null, 8, ["model-value", "items", "label", "error-messages", "hide-details", "data-testid"]),
    (requiresText.value)
      ? (_openBlock(), _createBlock(_component_v_textarea, {
          key: 0,
          "model-value": _ctx.modelValue.note,
          label: "Descreva o motivo *",
          placeholder: "Conte em poucas palavras o que aconteceu",
          variant: "outlined",
          color: "primary20",
          "bg-color": "white",
          rows: "3",
          "auto-grow": "",
          counter: _unref(CHANGE_REASON_NOTE_MAX),
          "counter-value": _unref(changeReasonNoteLength),
          maxlength: _unref(CHANGE_REASON_NOTE_MAX),
          "persistent-hint": "",
          hint: "Obrigatório para este motivo",
          "error-messages": noteErrors.value,
          "data-testid": `change-reason-note-input-${_ctx.kind}`,
          "onUpdate:modelValue": onNote
        }, null, 8, ["model-value", "counter", "counter-value", "maxlength", "error-messages", "data-testid"]))
      : _createCommentVNode("", true),
    (_ctx.scopeNote)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "flex items-center gap-2 text-sm text-textPrimary",
          "data-testid": `change-reason-scope-note-${_ctx.kind}`
        }, [
          _createVNode(_component_v_icon, {
            icon: _unref(mdiInformationOutline),
            color: "primary",
            size: "18"
          }, null, 8, ["icon"]),
          _createElementVNode("span", null, _toDisplayString(_ctx.scopeNote), 1)
        ], 8, _hoisted_6))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})